<!-- <a *ngIf="!isFromSM">
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWUSERINFO'] | translate}}" [routerLink]="routerLinkViewUser">Benutzerinformation</button>
</a> -->

<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWUSERINFO'] | translate}}" [routerLink]="routerLinkViewUser">Benutzerinformation</button>
</a>

<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}" (click)="deleteUser()">Entfernen</button>
</a>

